import { render, staticRenderFns } from "./jt1078-cmd-modal.vue?vue&type=template&id=87a4390e"
import script from "./jt1078-cmd-modal.vue?vue&type=script&lang=js"
export * from "./jt1078-cmd-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports